/** Support FAB form title (Figma 18px). No info subtitle under this title. */
export const GET_IN_TOUCH_SUPPORT_FAB_TITLE = 'Need help?';

export type SupportFabGetInTouchContent = {
  title: string;
};

/**
 * Resolve Support FAB form title before navigation so the destination
 * can render “Need help?” on first paint (no info text).
 */
export function resolveSupportFabGetInTouchContent(): SupportFabGetInTouchContent {
  return {
    title: GET_IN_TOUCH_SUPPORT_FAB_TITLE,
  };
}
